import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, Link } from "react-router-dom";
import moment from "moment";

import {
  GetAllPermohonan,
  GetAllPermohonanVerifikasi,
  reset,
} from "../../../features/permohonan/PermohonanSlice";

import {
  Card,
  Table,
  ButtonGroup,
  Button,
  InputGroup,
  Form,
} from "@themesberg/react-bootstrap";

import AdminLayout from "../../../layout/admin";
import { Header, PaginationComponent } from "../../../components/admin";

import {
  faSearch,
  faPlus,
  faEye,
  faTrash,
  faPrint,
  faCheck,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  hideLoadingDialog,
  showAlertDialog,
  showFailedDialog,
  showLoadingDialog,
  showSuccessDialog,
} from "../../../helpers/dialog.helper";
import axios from "axios";
import BASE_URL from "../../../api";
import { UserContext } from "../../../utils/ProtectedRoute";

const ListPermohonanPage = () => {
  const sortByList = [
    {
      id: "a.created_at",
      name: "Tanggal Permohonan",
    },
    {
      id: "a.nomor_permohonan",
      name: "Nomor Permohonan",
    },
  ];

  const sortTypeList = [
    {
      id: "ASC",
      name: "Paling Awal",
    },
    {
      id: "DESC",
      name: "Paling Akhir",
    },
  ];

  const [query, setQuery] = useState("");
  const [sortBy, setSortBy] = useState("a.created_at");
  const [sortType, setSortType] = useState("DESC");
  const [row, setRow] = useState("10");
  const [page, setPage] = useState("1");
  const [isDone, setIsDone] = useState(false);

  const { pathname } = useLocation();

  const dispatch = useDispatch();
  const { data, isLoading } = useSelector((state) => state.permohonan);

  const token = localStorage.getItem("token");

  // get user data from context to validate which menu has shown and hide
  // for the current user
  const { userData } = useContext(UserContext);

  useEffect(() => {
    fetchDataListPermohonan();
  }, [dispatch, token, page, query, sortBy, sortType, row, isDone, userData]);

  const handleSearch = (e) => {
    e.preventDefault();
    fetchDataListPermohonan();
  };

  const fetchDataListPermohonan = () => {
    dispatch(reset());
    // if it is mahasiswa
    if (userData?.id_role === "HA05") {
      dispatch(
        GetAllPermohonan({
          token: `${token}`,
          query: `?pageNumber=${page}&q=${query}&sortBy=${sortBy}&sortType=${sortType}&pageSize=${row}`,
        })
      );
    } else {
      dispatch(
        GetAllPermohonanVerifikasi({
          token: `${token}`,
          query: `?pageNumber=${page}&q=${query}&sortBy=${sortBy}&sortType=${sortType}&pageSize=${row}&isDone=${isDone}`,
        })
      );
    }
  };

  const handlePagination = (item) => {
    setPage(item);
  };

  const onClickDelete = (id) => {
    showAlertDialog({
      title: "Hapus?",
      msg: "Apakah anda yakin ingin menghapus ini?",
      confirmButtonText: "Hapus",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          if (id) {
            response = await axios.delete(`${BASE_URL}permohonan/${id}`, {
              headers: {
                Authorization: token,
              },
            });
            console.log("RESPONSE : ", response);
            hideLoadingDialog();
            showSuccessDialog({
              title: "Berhasil!",
              msg: "Berhasil menghapus data!",
            });
            fetchDataListPermohonan();
          } else {
            throw "id not found!";
          }
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menghapus data!",
          });
        }
      },
    });
  };
  
  const onClickDownload = async (id) => {
    showLoadingDialog();
    try {
      let response;
      if (id) {
        response = await axios.get(`${BASE_URL}permohonan/get_letter/${id}`, {
          headers: {
            Authorization: token,
          },
          responseType: "blob",
        });
        hideLoadingDialog();
        // download the file and open it in new tab
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        const contentDisposition = response.headers["content-disposition"] || response.headers.get("content-disposition");
        let fileName = `surat_permohonan_${id}`;
        if (contentDisposition) {          
          const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (fileNameMatch != null && fileNameMatch[1]) { 
            fileName = fileNameMatch[1].replace(/['"]/g, '');
          }
        }
        const fileType = response.headers['content-type'];
        link.setAttribute("download", `${fileName}.${fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ? 'docx' : fileType.split('/')[1]}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        throw "id not found!";
      }
    } catch (error) {
      console.log("ERROR", error);
      hideLoadingDialog();
      showFailedDialog({
        title: "Oops!",
        msg: error?.response?.data?.message || "Gagal mendownload data!",
      });
    }
  };

  return (
    <AdminLayout>
      <Header title="Permohonan Surat">
        {userData?.id_role === "HA05" ? (
          <Button
            as={Link}
            variant="outline-primary"
            size="sm"
            to={`/${pathname.split("/")[1]}/create`}
          >
            <FontAwesomeIcon icon={faPlus} className="me-2" />
            Tambah
          </Button>
        ) : (
          <Button
            variant="outline-primary"
            size="sm"
            onClick={() => setIsDone(!isDone)}
          >
            <FontAwesomeIcon icon={isDone ? faCheck : faSpinner} className="me-2" />
            {isDone ? 'Selesai' : 'Belum Selesai'}
          </Button>
        )}
      </Header>
      <Card border="light" className="shadow-sm mb-4">
        <Card.Header>
          <div className="table-settings mb-4">
            <div className="d-flex justify-content-between">
              <form onSubmit={handleSearch}>
                <InputGroup>
                  <InputGroup.Text>
                    <FontAwesomeIcon icon={faSearch} />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                  />
                </InputGroup>
              </form>
              <div className="d-flex gap-3">
                <Form.Group>
                  <Form.Select
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                  >
                    {sortByList.map((item, i) => (
                      <option key={i} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group>
                  <Form.Select
                    value={sortType}
                    onChange={(e) => setSortType(e.target.value)}
                  >
                    {sortTypeList.map((item, i) => (
                      <option key={i} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </div>
            </div>
          </div>
        </Card.Header>
        <Card.Body>
          <Table
            responsive
            striped
            className="table-centered table-nowrap rounded mb-0"
          >
            <thead className="thead-light">
              <tr>
                <th className="border-0">#</th>
                <th className="border-0">Nomor Permohonan</th>
                <th className="border-0">Layanan</th>
                <th className="border-0">Keterangan</th>
                <th className="border-0">Status</th>
                <th className="border-0">Flag</th>
                <th className="border-0">Tanggal Dibuat</th>
                <th className="border-0">Action</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <th colSpan="8" style={{ textAlign: "center" }}>
                    Loading
                  </th>
                </tr>
              ) : (data?.items || []).length > 0 ? (
                data?.items?.map((item, i) => (
                  <tr key={item.id}>
                    <th>{((page-1)*10) + (i + 1)}</th>
                    <th>{item.nomor_permohonan}</th>
                    <th>{item.nama_layanan}</th>
                    <th>{item.keterangan}</th>
                    <th>{item.str_status}</th>
                    <th>{item.flag_revisi ? 'REVISI' : item.is_rejected ? 'DITOLAK' : '-'}</th>
                    <th>
                      {moment(item.tanggal_permohonan).format(
                        "DD MMM YYYY HH:mm:ss"
                      )}
                    </th>
                    <th>
                      <ButtonGroup size="sm">
                        <Button as={Link} to={`/permohonan/detail/${item.id}`}>
                          <FontAwesomeIcon icon={faEye} />
                        </Button>
                        {/* BUTTON TO DOWNLOAD THE FILE */}
                        {item.path_dokumen_upload_final || (item.status === "5" && item.is_generated) ? (
                          <Button
                            variant="info"
                            onClick={() => {
                              if (item.path_dokumen_upload_final) {
                                window.open(item.path_dokumen_upload_final, "_blank");
                              } else {
                                onClickDownload(item.id);
                              }
                            }}
                          >
                            <FontAwesomeIcon icon={faPrint} />
                          </Button>
                        ) : null}
                        {/* BUTTON TO DELETE */}
                        {item.status === "0" ? (
                          <Button
                            variant="danger"
                            onClick={() => onClickDelete(item.id)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </Button>
                        ) : null}
                      </ButtonGroup>
                    </th>
                  </tr>
                ))
              ) : (
                <tr>
                  <th colSpan="8" style={{ textAlign: "center" }}>
                    Tidak ada data!
                  </th>
                </tr>
              )}
            </tbody>
          </Table>
        </Card.Body>
        <Card.Footer>
          <div className="table-settings mb-4">
            <div className="d-flex justify-content-between align-items-center">
              <Form.Group>
                <Form.Select
                  placeholder="Row"
                  value={row}
                  onChange={(e) => setRow(e.target.value)}
                >
                  <option defaultValue="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                </Form.Select>
              </Form.Group>

              <PaginationComponent
                meta={data?.meta}
                handlePagination={(item) => handlePagination(item)}
              />
            </div>
          </div>
        </Card.Footer>
      </Card>
    </AdminLayout>
  );
};

export default ListPermohonanPage;
